module.exports = __webpack_public_path__ + "img/principalImage.92dc843e.png";